import React, { useState, useEffect } from "react";
import { Card, CardHeader, Divider, CardContent } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

const columnsTTF = [
  {
    field: "name",
    headerName: "Position",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "time_to_fill",
    headerName: "Time To Fill",
    description: "Time to fill (days)",
    type: "number",
    flex: 1,
    headerAlign: "center",
    align: "center",
    valueGetter: (params) => {
      if (params.row.time_to_fill === null) {
        return "no data";
      } else {
        return `${params.row.time_to_fill}`;
      }
    },
  },
];

export default function ClientPosListOverview({ positions }) {
  return (
    <Card>
      <CardHeader title="Positions by Time to Fill" />
      <Divider />
      <CardContent>
        <div style={{ height: 300, width: "100%" }}>
          <DataGrid
            rows={positions}
            columns={columnsTTF}
            pageSize={20}
            rowsPerPageOptions={[20]}
            checkboxSelecheckboxSelection={false}
            initialState={{
              sorting: {
                sortModel: [{ field: "time_to_fill", sort: "asc" }],
              },
            }}
          />
        </div>
      </CardContent>
    </Card>
  );
}
